import { InjectionToken } from '@angular/core';
import { OktaOptions } from './models/okta-options';

export const OKTA_OPTIONS = new InjectionToken<OktaOptions>(
  'gdl.auth.okta.options'
);
